import React, { useCallback, useMemo } from 'react';
import CircleIcon from '@mui/icons-material/Circle';
import { Tooltip } from '@mui/material';
import PropTypes from 'prop-types';
import { ALERT_LABEL } from '../../../const/CommonConst';

/** @param {{ flag: string, iconSize?: string }} props */
const AlertHealthIndicator = ({ flag, iconSize }) => {
  const alertLabel = useMemo(() => {
    return ALERT_LABEL[flag] || flag;
  }, [flag]);

  const getAlertFlagColor = useCallback(
    (theme) => {
      switch (flag) {
        case 'Low':
          return theme?.palette?.success?.light;
        case 'Medium':
          return theme?.palette?.other?.modelPriorityMedium;
        case 'High':
          return theme?.palette?.error?.main;
        default:
          return theme?.palette?.text?.primary;
      }
    },
    [flag]
  );

  return (
    <Tooltip title={`${alertLabel}. Click to view overdue alerts`}>
      <CircleIcon
        fontSize="small"
        sx={{
          color: (theme) => getAlertFlagColor(theme),
          fill: (theme) => getAlertFlagColor(theme),
          ...(iconSize && { fontSize: iconSize }),
        }}
        {...(!iconSize && { fontSize: 'small' })}
      />
    </Tooltip>
  );
};
AlertHealthIndicator.propTypes = {
  flag: PropTypes.string.isRequired,
  iconSize: PropTypes.string,
};

export default AlertHealthIndicator;
